var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#40C5E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1759 27.6762H16.823V25.0864C16.8543 25.0875 16.8858 25.088 16.9175 25.088H28.1792C29.4366 25.088 30.5253 24.2455 30.7981 23.0612L32.2885 16.5906C32.3309 16.4063 32.3524 16.218 32.3524 16.0292C32.3524 14.5997 31.1513 13.4409 29.6696 13.4409H16.9175C16.8858 13.4409 16.8543 13.4415 16.823 13.4425V10.8527C16.823 10.138 16.2436 9.55859 15.5288 9.55859H12.9406C12.2259 9.55859 11.6465 10.138 11.6465 10.8527C11.6465 11.5674 12.2259 12.1468 12.9406 12.1468H14.2347V28.9704C14.2347 29.6851 14.8141 30.2645 15.5288 30.2645H27.1759C27.8906 30.2645 28.47 29.6851 28.47 28.9704C28.47 28.2556 27.8906 27.6762 27.1759 27.6762ZM18.1171 33.4999C18.1171 34.572 17.248 35.441 16.1759 35.441C15.1038 35.441 14.2347 34.572 14.2347 33.4999C14.2347 32.4278 15.1038 31.5587 16.1759 31.5587C17.248 31.5587 18.1171 32.4278 18.1171 33.4999ZM27.823 35.441C28.8951 35.441 29.7641 34.572 29.7641 33.4999C29.7641 32.4278 28.8951 31.5587 27.823 31.5587C26.7509 31.5587 25.8818 32.4278 25.8818 33.4999C25.8818 34.572 26.7509 35.441 27.823 35.441ZM16.823 22.4999V16.0293H29.7641L28.2516 22.4999H16.823Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.88397df5a09255a2ae811a79c82168d3.svg";
export { ForwardRef as ReactComponent };